import {
    TEST,
    CLEAR_CABINET_STATE,
    SET_SETTINGS_VERIFY_MODAL_STATUS,
    SET_SETTINGS_ADD_WALLET_MODAL_STATUS,
    SET_SETTINGS_EDIT_WALLET_MODAL_STATUS,
    SET_FREEZE_OMT_HONEE_MODAL_STATUS,
    SET_EXTEND_FREEZE_MODAL_STATUS,
    SET_STAKE_MODAL_STATUS,
    CLEAR_VERIFY_EMAIL_ERROR,
    GET_PROJECTS_ALL_STARTED,
    GET_PROJECTS_ALL_SUCCESS,
    GET_PROJECTS_ALL_FAILURE,
    GET_PROJECT_STARTED,
    GET_PROJECT_SUCCESS,
    GET_PROJECT_FAILURE,
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    SET_USER_NAME_STARTED,
    SET_USER_NAME_SUCCESS,
    SET_USER_NAME_FAILURE,
    DISCONNECT_USER_STARTED,
    DISCONNECT_USER_SUCCESS,
    DISCONNECT_USER_FAILURE,
    GET_LAUNCHPAD_STATUSES_STARTED,
    GET_LAUNCHPAD_STATUSES_SUCCESS,
    GET_LAUNCHPAD_STATUSES_FAILURE,
    CHANGE_USER_NAME_STARTED,
    CHANGE_USER_NAME_SUCCESS,
    CHANGE_USER_NAME_FAILURE,
    CHANGE_USER_AVATAR_STARTED,
    CHANGE_USER_AVATAR_SUCCESS,
    CHANGE_USER_AVATAR_FAILURE,
    GET_USER_PROJECTS_STARTED,
    GET_USER_PROJECTS_SUCCESS,
    GET_USER_PROJECTS_FAILURE,
    CHANGE_USER_EMAIL_STARTED,
    CHANGE_USER_EMAIL_SUCCESS,
    CHANGE_USER_EMAIL_FAILURE,
    RESEND_VERIFY_CODE_STARTED,
    RESEND_VERIFY_CODE_SUCCESS,
    RESEND_VERIFY_CODE_FAILURE,
    VERIFY_USER_EMAIL_STARTED,
    VERIFY_USER_EMAIL_SUCCESS,
    VERIFY_USER_EMAIL_FAILURE,
    GET_USER_ADDED_WALLETS_STARTED,
    GET_USER_ADDED_WALLETS_SUCCESS,
    GET_USER_ADDED_WALLETS_FAILURE,
    GET_WALLETS_NETWORKS_STARTED,
    GET_WALLETS_NETWORKS_SUCCESS,
    GET_WALLETS_NETWORKS_FAILURE,
    ADD_WALLET_STARTED,
    ADD_WALLET_SUCCESS,
    ADD_WALLET_FAILURE,
    EDIT_WALLET_STARTED,
    EDIT_WALLET_SUCCESS,
    EDIT_WALLET_FAILURE,
    GET_TOKEN_FREEZE_DATA_STARTED,
    GET_TOKEN_FREEZE_DATA_SUCCESS,
    GET_TOKEN_FREEZE_DATA_FAILURE,
    FREEZE_OMT_WITH_HONEE_STARTED,
    FREEZE_OMT_WITH_HONEE_SUCCESS,
    FREEZE_OMT_WITH_HONEE_FAILURE,
    GET_FREEZE_HISTORY_STARTED,
    GET_FREEZE_HISTORY_SUCCESS,
    GET_FREEZE_HISTORY_FAILURE,
    EXTEND_FREEZE_STARTED,
    EXTEND_FREEZE_SUCCESS,
    EXTEND_FREEZE_FAILURE,
    CLOSE_FREEZE_STARTED,
    CLOSE_FREEZE_SUCCESS,
    CLOSE_FREEZE_FAILURE,
    JOIN_PROJECT_STARTED,
    JOIN_PROJECT_SUCCESS,
    JOIN_PROJECT_FAILURE,
    GET_LAUNCHPAD_MAIN_STARTED,
    GET_LAUNCHPAD_MAIN_SUCCESS,
    GET_LAUNCHPAD_MAIN_FAILURE,
    GET_PROJECTS_LAST_STARTED,
    GET_PROJECTS_LAST_SUCCESS,
    GET_PROJECTS_LAST_FAILURE,
    SET_SETTINGS_ALLOCATION_DETAILS_MODAL_STATUS,
    SET_ALLOCATION_MODAL_STATUS,
    SET_ALLOCATION_HONEE_INVEST_STARTED,
    SET_ALLOCATION_HONEE_INVEST_SUCCESS,
    SET_ALLOCATION_HONEE_INVEST_FAILURE,
    SET_ALLOCATION_QR_INVEST_STARTED,
    SET_ALLOCATION_QR_INVEST_SUCCESS,
    SET_ALLOCATION_QR_INVEST_FAILURE,
    GET_USER_ALLOCATION_STARTED,
    GET_USER_ALLOCATION_SUCCESS,
    GET_USER_ALLOCATION_FAILURE,
    SET_ALLOCATION_HASH_STARTED,
    SET_ALLOCATION_HASH_SUCCESS,
    SET_ALLOCATION_HASH_FAILURE,
    GET_ALLOCATION_VESTING_DETAILS_STARTED,
    GET_ALLOCATION_VESTING_DETAILS_SUCCESS,
    GET_ALLOCATION_VESTING_DETAILS_FAILURE,
    CHECK_ACADEMY_STARTED,
    CHECK_ACADEMY_SUCCESS,
    CHECK_ACADEMY_FAILURE,
    WALLET_TRANSACTION_CHECK_STARTED,
    WALLET_TRANSACTION_CHECK_SUCCESS,
    WALLET_TRANSACTION_CHECK_FAILURE,
    GET_PREVIEW_PROJECT_STARTED,
    GET_PREVIEW_PROJECT_SUCCESS,
    GET_PREVIEW_PROJECT_FAILURE
} from "./types";


const initialState = {
    test: false,
    settingsVerifyModalStatus: false,
    settingsAddWalletModalStatus: false,
    settingsEditWalletModalStatus: {status: false, data: false},
    stakeModalStatus: false,
    allocationModalStatus: false,
    extendFreezeModalStatus: {status: false, id: false},
    settingsAllocationDetailsModalStatus: {status: false, data: false},
    freezeOmtHoneeModalStatus: false,
    projectsAllStarted: false,
    projectsAll: false,
    projectsAllErr: false,
    projectStarted: false,
    project: false,
    projectErr: false,
    userDataStarted: false,
    userData: false,
    userDataErr: false,
    userNameStarted: false,
    userName: false,
    userNameErr: false,
    disconnectUserStatusStarted: false,
    disconnectUserStatus: false,
    disconnectUserStatusErr: false,
    launchpadStatusesStarted: false,
    launchpadStatuses: false,
    launchpadStatusesErr: false,
    changeUserNameStatusStarted: false,
    changeUserNameStatus: false,
    changeUserNameStatusErr: false,
    changeUserAvatarStatusStarted: false,
    changeUserAvatarStatus: false,
    changeUserAvatarStatusErr: false,
    userProjectsStarted: false,
    userProjects: false,
    userProjectsErr: false,
    changeUserEmailStatusStarted: false,
    changeUserEmailStatus: false,
    changeUserEmailStatusErr: false,
    resendVerifyCodeStatusStarted: false,
    resendVerifyCodeStatus: false,
    resendVerifyCodeStatusErr: false,
    verifyUserEmailStatusStarted: false,
    verifyUserEmailStatus: false,
    verifyUserEmailStatusErr: false,
    userAddedWalletsStarted: false,
    userAddedWallets: false,
    userAddedWalletsErr: false,
    walletsNetworksStarted: false,
    walletsNetworks: false,
    walletsNetworksErr: false,
    addWalletStatusStarted: false,
    addWalletStatus: false,
    addWalletStatusErr: false,
    editWalletStatusStarted: false,
    editWalletStatus: false,
    editWalletStatusErr: false,
    tokenFreezeDataStarted: false,
    tokenFreezeData: false,
    tokenFreezeDataErr: false,
    freezeOmtWithHoneeStatusStarted: false,
    freezeOmtWithHoneeStatus: false,
    freezeOmtWithHoneeStatusErr: false,
    freezeHistoryStarted: false,
    freezeHistory: false,
    freezeHistoryErr: false,
    extendFreezeStatusStarted: false,
    extendFreezeStatus: false,
    extendFreezeStatusErr: false,
    closeFreezeStatusStarted: false,
    closeFreezeStatus: false,
    closeFreezeStatusErr: false,
    joinProjectStatusStarted: false,
    joinProjectStatus: false,
    joinProjectStatusErr: false,
    launchpadMainStarted: false,
    launchpadMain: false,
    launchpadMainErr: false,
    projectsLastStarted: false,
    projectsLast: false,
    projectsLastErr: false,
    allocationHoneeInvestStarted: false,
    allocationHoneeInvest: false,
    allocationHoneeInvestErr: false,
    allocationQrInvestStarted: false,
    allocationQrInvest: false,
    allocationQrInvestErr: false,
    userAllocationStarted: false,
    userAllocation: false,
    userAllocationErr: false,
    allocationHashStatusStarted: false,
    allocationHashStatus: false,
    allocationHashStatusErr: false,
    allocationVestingDetailsStarted: false,
    allocationVestingDetails: false,
    allocationVestingDetailsErr: false,
    checkAcademyStatusStarted: false,
    checkAcademyStatus: false,
    checkAcademyStatusErr: false,
    walletTransactionCheckStarted: false,
    walletTransactionCheck: false,
    walletTransactionCheckErr: false,
    previewProjectStarted: false,
    previewProject: false,
    previewProjectErr: false,
};

export function cabinetReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_STAKE_MODAL_STATUS:
            return {
                ...state,
                stakeModalStatus: action.payload
            };
        case SET_ALLOCATION_MODAL_STATUS:
            return {
                ...state,
                allocationModalStatus: action.payload
            };
        case SET_SETTINGS_ALLOCATION_DETAILS_MODAL_STATUS:
            return {
                ...state,
                settingsAllocationDetailsModalStatus: action.payload
            };
        case SET_FREEZE_OMT_HONEE_MODAL_STATUS:
            return {
                ...state,
                freezeOmtHoneeModalStatus: action.payload
            };
        case SET_EXTEND_FREEZE_MODAL_STATUS:
            return {
                ...state,
                extendFreezeModalStatus: action.payload
            };
        case SET_SETTINGS_VERIFY_MODAL_STATUS:
            return {
                ...state,
                settingsVerifyModalStatus: action.payload
            };
        case SET_SETTINGS_ADD_WALLET_MODAL_STATUS:
            return {
                ...state,
                settingsAddWalletModalStatus: action.payload
            };
        case SET_SETTINGS_EDIT_WALLET_MODAL_STATUS:
            return {
                ...state,
                settingsEditWalletModalStatus: action.payload
            };
        case GET_PROJECTS_ALL_STARTED:
            return {
                ...state,
                projectsAllStarted: true
            };
        case GET_PROJECTS_ALL_SUCCESS:
            return {
                ...state,
                projectsAll: action.payload,
                projectsAllStarted: false
            };
        case GET_PROJECTS_ALL_FAILURE:
            return {
                ...state,
                projectsAllErr: action.payload,
                projectsAllStarted: false
            };
        case GET_PROJECT_STARTED:
            return {
                ...state,
                projectStarted: true
            };
        case GET_PROJECT_SUCCESS:
            return {
                ...state,
                project: action.payload,
                projectStarted: false
            };
        case GET_PROJECT_FAILURE:
            return {
                ...state,
                projectErr: action.payload,
                projectStarted: false
            };
        case GET_USER_DATA_STARTED:
            return {
                ...state,
                userDataStarted: true
            };
        case GET_USER_DATA_SUCCESS:
            return {
                ...state,
                userData: action.payload,
                userDataStarted: false
            };
        case GET_USER_DATA_FAILURE:
            return {
                ...state,
                userDataErr: action.payload,
                userDataStarted: false
            };
        case SET_USER_NAME_STARTED:
            return {
                ...state,
                userNameStarted: true
            };
        case SET_USER_NAME_SUCCESS:
            return {
                ...state,
                userName: action.payload,
                userNameStarted: false
            };
        case SET_USER_NAME_FAILURE:
            return {
                ...state,
                userNameErr: action.payload,
                userNameStarted: false
            };
        case DISCONNECT_USER_STARTED:
            return {
                ...state,
                disconnectUserStatusStarted: true
            };
        case DISCONNECT_USER_SUCCESS:
            return {
                ...state,
                disconnectUserStatus: action.payload,
                disconnectUserStatusStarted: false
            };
        case DISCONNECT_USER_FAILURE:
            return {
                ...state,
                disconnectUserStatusErr: action.payload,
                disconnectUserStatusStarted: false
            };
        case GET_LAUNCHPAD_STATUSES_STARTED:
            return {
                ...state,
                launchpadStatusesStarted: true
            };
        case GET_LAUNCHPAD_STATUSES_SUCCESS:
            return {
                ...state,
                launchpadStatuses: action.payload,
                launchpadStatusesStarted: false
            };
        case GET_LAUNCHPAD_STATUSES_FAILURE:
            return {
                ...state,
                launchpadStatusesErr: action.payload,
                launchpadStatusesStarted: false
            };
        case CHANGE_USER_NAME_STARTED:
            return {
                ...state,
                changeUserNameStatusStarted: true
            };
        case CHANGE_USER_NAME_SUCCESS:
            return {
                ...state,
                changeUserNameStatus: action.payload,
                changeUserNameStatusStarted: false
            };
        case CHANGE_USER_NAME_FAILURE:
            return {
                ...state,
                changeUserNameStatusErr: action.payload,
                changeUserNameStatusStarted: false
            };
        case CHANGE_USER_AVATAR_STARTED:
            return {
                ...state,
                changeUserAvatarStatusStarted: true
            };
        case CHANGE_USER_AVATAR_SUCCESS:
            return {
                ...state,
                changeUserAvatarStatus: action.payload,
                changeUserAvatarStatusStarted: false
            };
        case CHANGE_USER_AVATAR_FAILURE:
            return {
                ...state,
                changeUserAvatarStatusErr: action.payload,
                changeUserAvatarStatusStarted: false
            };
        case GET_USER_PROJECTS_STARTED:
            return {
                ...state,
                userProjectsStarted: true
            };
        case GET_USER_PROJECTS_SUCCESS:
            return {
                ...state,
                userProjects: action.payload,
                userProjectsStarted: false
            };
        case GET_USER_PROJECTS_FAILURE:
            return {
                ...state,
                userProjectsErr: action.payload,
                userProjectsStarted: false
            };
        case CHANGE_USER_EMAIL_STARTED:
            return {
                ...state,
                changeUserEmailStatusStarted: true
            };
        case CHANGE_USER_EMAIL_SUCCESS:
            return {
                ...state,
                changeUserEmailStatus: action.payload,
                changeUserEmailStatusStarted: false
            };
        case CHANGE_USER_EMAIL_FAILURE:
            return {
                ...state,
                changeUserEmailStatusErr: action.payload,
                changeUserEmailStatusStarted: false
            };
        case RESEND_VERIFY_CODE_STARTED:
            return {
                ...state,
                resendVerifyCodeStatusStarted: true
            };
        case RESEND_VERIFY_CODE_SUCCESS:
            return {
                ...state,
                resendVerifyCodeStatus: action.payload,
                resendVerifyCodeStatusStarted: false
            };
        case RESEND_VERIFY_CODE_FAILURE:
            return {
                ...state,
                resendVerifyCodeStatusErr: action.payload,
                resendVerifyCodeStatusStarted: false
            };
        case VERIFY_USER_EMAIL_STARTED:
            return {
                ...state,
                verifyUserEmailStatusStarted: true
            };
        case VERIFY_USER_EMAIL_SUCCESS:
            return {
                ...state,
                verifyUserEmailStatus: action.payload,
                verifyUserEmailStatusStarted: false
            };
        case VERIFY_USER_EMAIL_FAILURE:
            return {
                ...state,
                verifyUserEmailStatusErr: action.payload,
                verifyUserEmailStatusStarted: false
            };
        case CLEAR_VERIFY_EMAIL_ERROR:
            return {
                ...state,
                verifyUserEmailStatusErr: false
            };
        case GET_USER_ADDED_WALLETS_STARTED:
            return {
                ...state,
                userAddedWalletsStarted: true
            };
        case GET_USER_ADDED_WALLETS_SUCCESS:
            return {
                ...state,
                userAddedWallets: action.payload,
                userAddedWalletsStarted: false
            };
        case GET_USER_ADDED_WALLETS_FAILURE:
            return {
                ...state,
                userAddedWalletsErr: action.payload,
                userAddedWalletsStarted: false
            };
        case GET_WALLETS_NETWORKS_STARTED:
            return {
                ...state,
                walletsNetworksStarted: true
            };
        case GET_WALLETS_NETWORKS_SUCCESS:
            return {
                ...state,
                walletsNetworks: action.payload,
                walletsNetworksStarted: false
            };
        case GET_WALLETS_NETWORKS_FAILURE:
            return {
                ...state,
                walletsNetworksErr: action.payload,
                walletsNetworksStarted: false
            };
        case ADD_WALLET_STARTED:
            return {
                ...state,
                addWalletStatusStarted: true
            };
        case ADD_WALLET_SUCCESS:
            return {
                ...state,
                addWalletStatus: action.payload,
                addWalletStatusStarted: false
            };
        case ADD_WALLET_FAILURE:
            return {
                ...state,
                addWalletStatusErr: action.payload,
                addWalletStatusStarted: false
            };
        case EDIT_WALLET_STARTED:
            return {
                ...state,
                editWalletStatusStarted: true
            };
        case EDIT_WALLET_SUCCESS:
            return {
                ...state,
                editWalletStatus: action.payload,
                editWalletStatusStarted: false
            };
        case EDIT_WALLET_FAILURE:
            return {
                ...state,
                editWalletStatusErr: action.payload,
                editWalletStatusStarted: false
            };
        case GET_TOKEN_FREEZE_DATA_STARTED:
            return {
                ...state,
                tokenFreezeDataStarted: true
            };
        case GET_TOKEN_FREEZE_DATA_SUCCESS:
            return {
                ...state,
                tokenFreezeData: action.payload,
                tokenFreezeDataStarted: false
            };
        case GET_TOKEN_FREEZE_DATA_FAILURE:
            return {
                ...state,
                tokenFreezeDataErr: action.payload,
                tokenFreezeDataStarted: false
            };
        case FREEZE_OMT_WITH_HONEE_STARTED:
            return {
                ...state,
                freezeOmtWithHoneeStatusStarted: true
            };
        case FREEZE_OMT_WITH_HONEE_SUCCESS:
            return {
                ...state,
                freezeOmtWithHoneeStatus: action.payload,
                freezeOmtWithHoneeStatusStarted: false
            };
        case FREEZE_OMT_WITH_HONEE_FAILURE:
            return {
                ...state,
                freezeOmtWithHoneeStatusErr: action.payload,
                freezeOmtWithHoneeStatusStarted: false
            };
        case GET_FREEZE_HISTORY_STARTED:
            return {
                ...state,
                freezeHistoryStarted: true,
                freezeHistoryErr: null,
            };

        case GET_FREEZE_HISTORY_SUCCESS: {
            const incoming = action.payload;                 // { freezes: { data, current_page, ... } }
            const isAppend = action.meta?.append === true;

            if (!isAppend) {
                // Полная замена (первая страница или смена фильтра)
                return {
                    ...state,
                    freezeHistory: incoming,
                    freezeHistoryStarted: false,
                    freezeHistoryErr: null,
                };
            }

            // Дозагрузка: склеиваем с тем, что уже есть
            const prevFreezes = state.freezeHistory?.freezes ?? {};
            const nextFreezes = incoming?.freezes ?? {};

            // Склейка + дедуп по id (на случай повторов)
            const mergedData = [
                ...(prevFreezes.data || []),
                ...(nextFreezes.data || []),
            ].reduce((acc, item) => {
                if (!acc._seen.has(item.id)) {
                    acc._seen.add(item.id);
                    acc.list.push(item);
                }
                return acc;
            }, { _seen: new Set(), list: [] }).list;

            const merged = {
                ...incoming,
                freezes: {
                    ...nextFreezes,           // актуальные мета-поля из последнего ответа (current_page, next_page_url, ...)
                    data: mergedData,         // склеенный и дедуплицированный список
                },
            };

            return {
                ...state,
                freezeHistory: merged,
                freezeHistoryStarted: false,
                freezeHistoryErr: null,
            };
        }

        case GET_FREEZE_HISTORY_FAILURE:
            return {
                ...state,
                freezeHistoryErr: action.payload,
                freezeHistoryStarted: false,
            };
        case EXTEND_FREEZE_STARTED:
            return {
                ...state,
                extendFreezeStatusStarted: true
            };
        case EXTEND_FREEZE_SUCCESS:
            return {
                ...state,
                extendFreezeStatus: action.payload,
                extendFreezeStatusStarted: false
            };
        case EXTEND_FREEZE_FAILURE:
            return {
                ...state,
                extendFreezeStatusErr: action.payload,
                extendFreezeStatusStarted: false
            };
        case CLOSE_FREEZE_STARTED:
            return {
                ...state,
                closeFreezeStatusStarted: true
            };
        case CLOSE_FREEZE_SUCCESS:
            return {
                ...state,
                closeFreezeStatus: action.payload,
                closeFreezeStatusStarted: false
            };
        case CLOSE_FREEZE_FAILURE:
            return {
                ...state,
                closeFreezeStatusErr: action.payload,
                closeFreezeStatusStarted: false
            };
        case JOIN_PROJECT_STARTED:
            return {
                ...state,
                joinProjectStatusStarted: true
            };
        case JOIN_PROJECT_SUCCESS:
            return {
                ...state,
                joinProjectStatus: action.payload,
                joinProjectStatusStarted: false
            };
        case JOIN_PROJECT_FAILURE:
            return {
                ...state,
                joinProjectStatusErr: action.payload,
                joinProjectStatusStarted: false
            };
        case GET_LAUNCHPAD_MAIN_STARTED:
            return {
                ...state,
                launchpadMainStarted: true
            };
        case GET_LAUNCHPAD_MAIN_SUCCESS:
            return {
                ...state,
                launchpadMain: action.payload,
                launchpadMainStarted: false
            };
        case GET_LAUNCHPAD_MAIN_FAILURE:
            return {
                ...state,
                launchpadMainErr: action.payload,
                launchpadMainStarted: false
            };
        case GET_PROJECTS_LAST_STARTED:
            return {
                ...state,
                projectsLastStarted: true
            };
        case GET_PROJECTS_LAST_SUCCESS:
            return {
                ...state,
                projectsLast: action.payload,
                projectsLastStarted: false
            };
        case GET_PROJECTS_LAST_FAILURE:
            return {
                ...state,
                projectsLastErr: action.payload,
                projectsLastStarted: false
            };
        case SET_ALLOCATION_HONEE_INVEST_STARTED:
            return {
                ...state,
                allocationHoneeInvestStarted: true
            };
        case SET_ALLOCATION_HONEE_INVEST_SUCCESS:
            return {
                ...state,
                allocationHoneeInvest: action.payload,
                allocationHoneeInvestStarted: false
            };
        case SET_ALLOCATION_HONEE_INVEST_FAILURE:
            return {
                ...state,
                allocationHoneeInvestErr: action.payload,
                allocationHoneeInvestStarted: false
            };
        case SET_ALLOCATION_QR_INVEST_STARTED:
            return {
                ...state,
                allocationQrInvestStarted: true
            };
        case SET_ALLOCATION_QR_INVEST_SUCCESS:
            return {
                ...state,
                allocationQrInvest: action.payload,
                allocationQrInvestStarted: false
            };
        case SET_ALLOCATION_QR_INVEST_FAILURE:
            return {
                ...state,
                allocationQrInvestErr: action.payload,
                allocationQrInvestStarted: false
            };
        case GET_USER_ALLOCATION_STARTED:
            return {
                ...state,
                userAllocationStarted: true
            };
        case GET_USER_ALLOCATION_SUCCESS:
            return {
                ...state,
                userAllocation: action.payload,
                userAllocationStarted: false
            };
        case GET_USER_ALLOCATION_FAILURE:
            return {
                ...state,
                userAllocationErr: action.payload,
                userAllocationStarted: false
            };
        case SET_ALLOCATION_HASH_STARTED:
            return {
                ...state,
                allocationHashStatusStarted: true
            };
        case SET_ALLOCATION_HASH_SUCCESS:
            return {
                ...state,
                allocationHashStatus: action.payload,
                allocationHashStatusStarted: false
            };
        case SET_ALLOCATION_HASH_FAILURE:
            return {
                ...state,
                allocationHashStatusErr: action.payload,
                allocationHashStatusStarted: false
            };
        case GET_ALLOCATION_VESTING_DETAILS_STARTED:
            return {
                ...state,
                allocationVestingDetailsStarted: true
            };
        case GET_ALLOCATION_VESTING_DETAILS_SUCCESS:
            return {
                ...state,
                allocationVestingDetails: action.payload,
                allocationVestingDetailsStarted: false
            };
        case GET_ALLOCATION_VESTING_DETAILS_FAILURE:
            return {
                ...state,
                allocationVestingDetailsErr: action.payload,
                allocationVestingDetailsStarted: false
            };
        case CHECK_ACADEMY_STARTED:
            return {
                ...state,
                checkAcademyStatusStarted: true
            };
        case CHECK_ACADEMY_SUCCESS:
            return {
                ...state,
                checkAcademyStatus: action.payload,
                checkAcademyStatusStarted: false
            };
        case CHECK_ACADEMY_FAILURE:
            return {
                ...state,
                checkAcademyStatusErr: action.payload,
                checkAcademyStatusStarted: false
            };
        case WALLET_TRANSACTION_CHECK_STARTED:
            return {
                ...state,
                walletTransactionCheckStarted: true
            };
        case WALLET_TRANSACTION_CHECK_SUCCESS:
            return {
                ...state,
                walletTransactionCheck: action.payload,
                walletTransactionCheckStarted: false
            };
        case WALLET_TRANSACTION_CHECK_FAILURE:
            return {
                ...state,
                walletTransactionCheckErr: action.payload,
                walletTransactionCheckStarted: false
            };
        case GET_PREVIEW_PROJECT_STARTED:
            return {
                ...state,
                previewProjectStarted: true
            };
        case GET_PREVIEW_PROJECT_SUCCESS:
            return {
                ...state,
                previewProject: action.payload,
                previewProjectStarted: false
            };
        case GET_PREVIEW_PROJECT_FAILURE:
            return {
                ...state,
                previewProjectErr: action.payload,
                previewProjectStarted: false
            };
        case CLEAR_CABINET_STATE:
            return {...initialState};
        default:
            return state;
    }
}

